import {Checkbox} from "@mui/material";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {ColumnId, IExportGroupProps} from "@ui/tableCustom/types/columns";
import {useMemo} from "react";

const buttonToggleColumnExportSx = {
    padding: 0,
}

interface IProps<T> {
    exportMutate: IExportMutateContext<T>,
    exportParams: IExportParamsContext<T>,
    id: ColumnId<T>,
    exportGroupProps: IExportGroupProps<T>,
}

function ButtonToggleColumnExportGroup<T>({
                                              exportMutate,
                                              exportParams,
                                              id,
                                              exportGroupProps

                                          }: IProps<T>) {
    const {
        onChangeColumn,
        columnExport
    } = exportMutate;


    const handleChange = () => {
        if (!onChangeColumn || !exportGroupProps?.groupIds?.length) {
            return
        }
        exportGroupProps.groupIds.forEach((id) => {
            onChangeColumn(id)
        })
    }


    const checked = useMemo(() => {
        if (!exportGroupProps?.groupIds?.length || !columnExport?.length) {
            return false
        }
        return exportGroupProps.groupIds.every((id) => columnExport.some((column) => column.id === id))

    }, [exportParams, exportMutate, exportGroupProps])


    return (
        <Checkbox
            sx={buttonToggleColumnExportSx}
            onChange={handleChange}
            checked={checked}
        />
    )
};
export default ButtonToggleColumnExportGroup;
